import {
  TcktStsTypeCpntPrdDplymnt,
  TcktStsTypeCpntStgDplymnt,
} from "../../util/general-code/enums/general-codes";
import { Option } from "../../util/option";

export const TEMPLATE_FILE_URL = {
  NORMAL: "spreadsheet-template/component-deployment-request-list-normal.xlsx",
  BEFORE_APPROVE:
    "spreadsheet-template/component-deployment-request-list-before-approve.xlsx",
  REVIEW: "spreadsheet-template/component-deployment-request-list-review.xlsx",
  WITHDRAW:
    "spreadsheet-template/component-deployment-request-list-withdraw.xlsx",
  RETRY: "spreadsheet-template/component-deployment-request-list-retry.xlsx",
  REVERT: "spreadsheet-template/component-deployment-request-list-revert.xlsx",
};

export const OPEN_PRD_TICKET_STATUS_LIST = [
  TcktStsTypeCpntPrdDplymnt.DEPLOYMENT_APPROVAL_PENDING,
  TcktStsTypeCpntPrdDplymnt.DEPLOYMENT_PENDING,
  TcktStsTypeCpntPrdDplymnt.DEPLOYING,
  TcktStsTypeCpntPrdDplymnt.WAITING_FOR_RETRY,
  TcktStsTypeCpntPrdDplymnt.DEPLOYMENT_FAILED,
  TcktStsTypeCpntPrdDplymnt.REVERT_DEPLOYMENT_APPROVAL_PENDING,
  TcktStsTypeCpntPrdDplymnt.REVERT_DEPLOYMENT_PENDING,
  TcktStsTypeCpntPrdDplymnt.REVERT_DEPLOYING,
  TcktStsTypeCpntPrdDplymnt.REVERT_WAITING_FOR_RETRY,
  TcktStsTypeCpntPrdDplymnt.REVERT_DEPLOYMENT_FAILED,
];
export const OPEN_STG_TICKET_STATUS_LIST = [
  TcktStsTypeCpntStgDplymnt.DEPLOYMENT_APPROVAL_PENDING,
  TcktStsTypeCpntStgDplymnt.DEPLOYMENT_PENDING,
  TcktStsTypeCpntStgDplymnt.DEPLOYING,
  TcktStsTypeCpntStgDplymnt.WAITING_FOR_RETRY,
  TcktStsTypeCpntStgDplymnt.DEPLOYMENT_FAILED,
  TcktStsTypeCpntStgDplymnt.REVERT_DEPLOYMENT_APPROVAL_PENDING,
  TcktStsTypeCpntStgDplymnt.REVERT_DEPLOYMENT_PENDING,
  TcktStsTypeCpntStgDplymnt.REVERT_DEPLOYING,
  TcktStsTypeCpntStgDplymnt.REVERT_WAITING_FOR_RETRY,
  TcktStsTypeCpntStgDplymnt.REVERT_DEPLOYMENT_FAILED,
];

export const HOUR_LIST: Option[] = [
  { label: "0", value: "0" },
  { label: "1", value: "1" },
  { label: "2", value: "2" },
  { label: "3", value: "3" },
  { label: "4", value: "4" },
  { label: "5", value: "5" },
  { label: "6", value: "6" },
  { label: "7", value: "7" },
  { label: "8", value: "8" },
  { label: "9", value: "9" },
  { label: "10", value: "10" },
  { label: "11", value: "11" },
  { label: "12", value: "12" },
  { label: "13", value: "13" },
  { label: "14", value: "14" },
  { label: "15", value: "15" },
  { label: "16", value: "16" },
  { label: "17", value: "17" },
  { label: "18", value: "18" },
  { label: "19", value: "19" },
  { label: "20", value: "20" },
  { label: "21", value: "21" },
  { label: "22", value: "22" },
  { label: "23", value: "23" },
];

export const DEPLOY_MINUTE_LIST: Option[] = [
  { label: "0", value: "0" },
  { label: "15", value: "15" },
  { label: "30", value: "30" },
  { label: "45", value: "45" },
];

const EDH_PROTOCOL_LABEL_DELIMITER = "/";

export const getMergedEdhProtocolValue: (
  inOutTypeCd: string,
  edhPrtclTypeCd: string,
) => string = (inOutTypeCd, edhPrtclTypeCd) => {
  return inOutTypeCd + EDH_PROTOCOL_LABEL_DELIMITER + edhPrtclTypeCd;
};

export const splitEdhProtocolValue = (edhProtocolValue: string) => {
  const [inOutTypeCd, edhPrtclTypeCd] = edhProtocolValue.split(
    EDH_PROTOCOL_LABEL_DELIMITER,
  );
  return [inOutTypeCd, edhPrtclTypeCd];
};
